const GERMAN_HINTS = [
  " der ",
  " die ",
  " das ",
  " und ",
  " oder ",
  " mit ",
  " für ",
  "kenntnisse",
  "berufserfahrung",
  "ausbildung",
  "studium",
  "deutschkenntnisse",
  "anforderungen",
  "qualifikation",
];

const LABELS = {
  de: {
    "Score Breakdown": "Bewertungserklärung",
    "Score rows show independent evidence signals. The final score is calculated separately from the full scoring model.":
      "Die Bewertungszeilen zeigen unabhÃ¤ngige Nachweise. Die Gesamtbewertung wird separat aus dem vollstÃ¤ndigen Bewertungsmodell berechnet.",
    "Final": "Gesamt",
    "Breakdown": "Aufschlüsselung",
    "Not set": "Nicht gesetzt",
    "Semantic relevance": "Semantische Relevanz",
    "Skill coverage": "Skill-Abdeckung",
    "Experience evidence": "Erfahrungsnachweis",
    "Language / education": "Sprache / Ausbildung",
    "Must-have skills": "Muss-Kriterien",
    "Preferred skills": "Wunsch-Kriterien",
    "Why this score?": "Warum diese Bewertung?",
    "Language Match": "Sprachabgleich",
    "Detected Skill Evidence": "Erkannte Skill-Nachweise",
    "Unconfirmed Skill Evidence": "UnbestÃ¤tigte Skill-Nachweise",
    "AI Matching Evidence": "KI-Matching-Nachweise",
    "AI Skill Gaps": "KI-Skill-Lücken",
    "How to read this:": "So liest du das:",
    "Matched": "Passend",
    "Gap": "Lücke",
    "Not detected": "Nicht erkannt",
    "Not scored": "Nicht bewertet",
    "Must-have": "Muss-Kriterium",
    "Preferred": "Wunsch-Kriterium",
    "passed": "erfüllt",
    "below target": "unter Zielwert",
    "found": "gefunden",
    "not found": "nicht gefunden",
    "Baseline match": "Basis-Match",
    "Must-have criteria": "Muss-Kriterien",
    "Preferred criteria": "Wunsch-Kriterien",
    "How closely the CV text matches the job description overall, even when wording differs.":
      "Wie gut der Lebenslauf insgesamt zur Stellenbeschreibung passt, auch wenn andere Formulierungen verwendet werden.",
    "How much of the detected job skill requirement is supported by skills found in the CV.":
      "Wie stark die erkannten Skill-Anforderungen der Stelle durch Skills im Lebenslauf abgedeckt sind.",
    "Whether required skills are proven inside work experience or project context, not only listed as keywords.":
      "Ob geforderte Skills in Berufserfahrung oder Projektkontext belegt sind und nicht nur als Stichworte erscheinen.",
    "Small supporting signal from language, qualification, or certification evidence when available.":
      "Kleines Zusatzsignal aus Sprache, Ausbildung oder Zertifizierungen, sofern vorhanden.",
    "How closely the CV text matches the job description before must-have and preferred criteria are applied.":
      "Wie gut der Lebenslauf zur Stellenbeschreibung passt, bevor Muss- und Wunsch-Kriterien angewendet werden.",
    "How closely the CV text matches the job description before criteria are applied.":
      "Wie gut der Lebenslauf zur Stellenbeschreibung passt, bevor Kriterien angewendet werden.",
    "Recruiter-selected critical skills.":
      "Vom Recruiter ausgewaehlte kritische Skills.",
    "Recruiter-selected critical skills. Weak evidence here can cap the final score.":
      "Vom Recruiter ausgewählte kritische Skills. Schwache Nachweise hier können die Gesamtbewertung begrenzen.",
    "Bonus skills that improve confidence, but should not reject a candidate by themselves.":
      "Zusätzliche Skills, die das Vertrauen erhöhen, aber allein keine Absage begründen sollten.",
    "Broad CV-to-job relevance plus detected role-skill overlap before recruiter criteria.":
      "Allgemeine CV-zur-Stelle-Relevanz plus erkannte Rollen- und Skill-Überschneidung vor Recruiter-Kriterien.",
    "This score uses semantic CV-to-job similarity and detected skill coverage.":
      "Diese Bewertung nutzt semantische CV-zur-Stelle-Ähnlichkeit und erkannte Skill-Abdeckung.",
    "The final score combines CV-to-job relevance, skill evidence, and recruiter-defined criteria.":
      "Die Gesamtbewertung kombiniert CV-zur-Stelle-Relevanz, Skill-Nachweise und vom Recruiter definierte Kriterien.",
    "use the final score for quick ranking, then use the breakdown to see whether the score came from broad relevance, required skills, or bonus criteria.":
      "nutze die Gesamtbewertung für eine schnelle Reihenfolge und die Aufschlüsselung, um zu sehen, ob die Bewertung aus allgemeiner Relevanz, Muss-Skills oder Zusatzkriterien stammt.",
    "semantic relevance shows broad CV-to-JD fit; skill coverage shows required stack overlap; experience evidence checks whether skills appear in work/project context; language or education adds a support signal.":
      "semantische Relevanz zeigt die allgemeine CV-zur-Stelle-Passung; Skill-Abdeckung zeigt Überschneidungen mit dem geforderten Stack; Erfahrungsnachweis prüft, ob Skills im Arbeits- oder Projektkontext vorkommen; Sprache oder Ausbildung liefert ein Zusatzsignal.",
    "higher semantic points mean the CV is broadly relevant; skill coverage shows requirement overlap; experience evidence checks real work context; language or education adds a support signal.":
      "höhere semantische Punkte bedeuten, dass der Lebenslauf insgesamt relevant ist; Skill-Abdeckung zeigt Anforderungsüberschneidung; Erfahrungsnachweis prüft echten Arbeitskontext; Sprache oder Ausbildung liefert ein Zusatzsignal.",
    "higher semantic points mean the CV is broadly relevant; higher skill points mean the required stack is better covered; experience evidence checks whether skills appear in work/project context; language or education adds a support signal.":
      "höhere semantische Punkte bedeuten, dass der Lebenslauf insgesamt relevant ist; höhere Skill-Punkte bedeuten, dass der geforderte Stack besser abgedeckt ist; Erfahrungsnachweis prüft, ob Skills im Arbeits- oder Projektkontext vorkommen; Sprache oder Ausbildung liefert ein Zusatzsignal.",
  },
};

export function isGermanContent(text = "") {
  const normalized = ` ${String(text).toLowerCase()} `;
  return GERMAN_HINTS.some((hint) => normalized.includes(hint));
}

export function scoringLabel(label, language = "en") {
  if (language !== "de") return label;
  return LABELS.de[label] || label;
}

export function localizedCriteriaReason(reason = "", language = "en") {
  if (language !== "de") return reason;

  const text = String(reason || "").trim();
  if (!text) return "";

  if (text === "No clear evidence found in CV.") {
    return "Kein klarer Nachweis im Lebenslauf gefunden.";
  }

  let match = text.match(/^Evidence: (.+) found in extracted CV skills\.$/);
  if (match) {
    return `Nachweis: ${match[1]} wurde in den erkannten CV-Skills gefunden.`;
  }

  match = text.match(/^Evidence: (.+) directly supports (.+)\.$/);
  if (match) {
    return `Nachweis: ${match[1]} unterstuetzt ${match[2]} direkt.`;
  }

  match = text.match(/^Evidence: (.+) found in CV text with work context\.$/);
  if (match) {
    return `Nachweis: ${match[1]} wurde im Lebenslauf mit Arbeitskontext gefunden.`;
  }

  match = text.match(/^Partial evidence: (.+) is related to (.+)\.$/);
  if (match) {
    return `Teilnachweis: ${match[1]} ist mit ${match[2]} verwandt.`;
  }

  return text;
}

export function localizedLanguageEducationDetail(qualification = "", languageRows = [], language = "en") {
  const parts = [];

  if (qualification) {
    parts.push(
      language === "de"
        ? `CV zeigt Ausbildungs-/Zertifizierungsnachweise: ${qualification}.`
        : `CV shows education/certification evidence: ${qualification}.`
    );
  }

  if (languageRows.length) {
    const languageDetails = languageRows
      .slice(0, 2)
      .map((item) => {
        const fitScore = Math.max(0, Math.min(100, Number(item?.fit_score ?? 0) || 0));
        const evidence = item.evidence ? ` (${item.evidence})` : "";
        return `${item.language || "Language"} ${fitScore}%${item.status ? `, ${item.status}` : ""}${evidence}`;
      })
      .join("; ");

    parts.push(
      language === "de"
        ? `Sprachnachweis: ${languageDetails}.`
        : `Language evidence: ${languageDetails}.`
    );
  }

  return parts.length
    ? parts.join(" ")
    : scoringLabel("Small supporting signal from language, qualification, or certification evidence when available.", language);
}

export function scoringLanguageFromText(text = "") {
  return isGermanContent(text) ? "de" : "en";
}
